import { AxiosRequestConfig } from 'axios'

export interface LevelChangeSummaryParams {
  startDate: string
  endDate: string
  storeId?: number
}

export interface LevelChangeSummaryData {
  upgraded: {
    count: number
    percentage: number
  }
  downgraded: {
    count: number
    percentage: number
  }
  activeUsersCount: number
}

export const getLevelChangeSummary = (params: LevelChangeSummaryParams): AxiosRequestConfig => ({
  url: '/dashboard/level-change-summary',
  method: 'GET',
  params,
})
